<app-processing [visible]="!pageVars.isReady"></app-processing>

<div class="flex justify-content-between align-content-middle w-100 mt-2 mb-3">
  <p-breadcrumb [model]="pageVars.breadcrumbItems">
    <ng-template let-item let-last="last" let-first="first" pTemplate="item">
      <ng-container *ngIf="!first">
        <a *ngIf="item.routerLink" [routerLink]="item.routerLink">{{ item.label }}</a>
        <div *ngIf="!item.routerLink" class="breadcrumb-current-item">{{ item.label }}</div>
      </ng-container>
    </ng-template>
  </p-breadcrumb>
  <div class="flex align-items-center justify-content-center">
  <p-button 
  pTooltip="Reset Table" 
  tooltipPosition="top" 
  icon="pi pi-refresh" 
  [raised]="true" 
  class="mr-2" 
  (click)="resetPage(dt)"></p-button>
  <p-button
    pTooltip="Clear Filter/Sort"
    tooltipPosition="top"
    *ngIf="filtersActive"
    icon="pi pi-filter-slash"
    [raised]="true"
    (click)="clearFilters(dt)"></p-button>
</div>
  <button pButton pRipple [raised]="true" class="action-btn mr-2" label="Export" (click)="export()"></button>
</div>



<ng-container>
  <p-table
    #dt
    [value]="instances"
    [columns]="cols"
    [paginator]="true"
    [reorderableColumns]="true"
    [resizableColumns]="true"
    columnResizeMode="expand"
    [first]="skip"
    [rows]="take"
    [totalRecords]="totalCount"
    [filterDelay]="300"
    [lazy]="true"
    stateStorage="local"
    stateKey="metrics-table"
    (onLazyLoad)="handleTableEvents($event)"
    [scrollable]="true"
    [scrollHeight]="'60vh'">

    
  <ng-template #header let-columns>
    <tr>
      <th *ngFor="let col of columns" pResizableColumn pReorderableColumn [pSortableColumn]="col.field"
        [ngStyle]="col.headerStyle || getColumnHeaderStyle(col.field)">
        {{ col.header }}
        <p-sortIcon [field]="col.field"></p-sortIcon>
        <p-columnFilter
          [type]="col.type"
          [field]="col.field"
          placeholder="Filter.."
          display="menu"
          class="ml-1"
          [matchModeOptions]="col.type === 'text' ? customMatchModeOptions : col.type === 'date' ? dateMatchModeOptions : col.type === 'numeric' ? numericMatchModeOptions : undefined">
        </p-columnFilter>
      </th>
    </tr>
  </ng-template>

  <ng-template #body let-order let-columns="columns">
    <tr>
      <td *ngFor="let col of columns" [ngStyle]="col.style">
        <ng-container [ngSwitch]="col.template">
          <a *ngSwitchCase="'link'" [routerLink]="['/orders', order.OrderId, 'metrics']">
            {{ order[col.field] }}
          </a>
          <div *ngSwitchCase="'variant'" style="white-space: normal; overflow-wrap: break-word; word-break: break-word">
            {{ order[col.field] }}
          </div>
          <div *ngSwitchCase="'tooltip'" [pTooltip]="order[col.field]" tooltipPosition="top" class="text-line-clamp-3">
            {{ order[col.field] }}
          </div>
          <span *ngSwitchCase="'boolean'">
            {{ order[col.field] === true ? 'Yes' : 'No' }}
          </span>
          <ng-container *ngSwitchDefault>
            {{ order[col.field] }}
          </ng-container>
        </ng-container>
      </td>
    </tr>
  </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="11">No order instances found.</td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
